module.exports = {"share":{"rowsPerPage":"Rows","rangeSeparator":"of","noData":"No Data"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/share.json
// module id = 541
// module chunks = 14